import { render, staticRenderFns } from "./add-services-materials.vue?vue&type=template&id=faf68640"
import script from "./add-services-materials.vue?vue&type=script&lang=js"
export * from "./add-services-materials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports